import * as React from "react";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import CancelIcon from "@mui/icons-material/Cancel";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import { ButtonGroup } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Header from "../Includes/Header";
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState, useEffect, useRef } from "react";
import { DialogContentText } from "@mui/material";
import {
  Card,
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
  Stack,
  FormGroup,
  FormControlLabel,
  Checkbox,
  InputAdornment,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Menu from "@mui/material/Menu";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";
import {
  retrieveAdminUser,
  AutocompleteAdminUser,
  DeleteAdminUser,
  StatusAdminUser,
  UpdateAdminUser,
} from "../Apihelper/ApiHelperUser";
import { useNavigate } from "react-router-dom";
import AppToast from '../../components/Toast/AppToast';
import ListPagination, { pickTotal } from "../../components/ListPagination/ListPagination";

// Constants
const drawerWidth = 292;

// Sidebar menu options for page access (must match Header menu items)
const SIDEBAR_PAGE_OPTIONS = [
  { id: "dashboard", label: "Dashboard" },
  { id: "follow up", label: "Follow Up" },
  { id: "members", label: "Members" },
  { id: "bulk whatsapp", label: "Bulk holiday WhatsApp" },
  { id: "packages", label: "Packages" },
  { id: "offers", label: "Offers" },
  { id: "due users", label: "Due Users" },
  { id: "balance", label: "Balance" },
  { id: "pt", label: "Pt" },
  { id: "diet", label: "Diet" },
  { id: "exercise", label: "Exercise" },
  { id: "expense", label: "Expense" },
  { id: "staff", label: "Staff" },
  { id: "users", label: "Users" },
  { id: "attendance", label: "Attendance" },
  { id: "operation logs", label: "Operation logs" },
  { id: "device logs", label: "Device Command Logs" },
];

// Styles
const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: '100%',
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      overflowX: "auto"
    }
  },
  table: {
    minWidth: 650,
    [theme.breakpoints.down("sm")]: {
      minWidth: 500
    }
    },
  searchContainer: {
    display: "flex",
    gap: "1rem",
    alignItems: "center",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch"
    }
  }
}));

function UserList(props) {
  const { colors: appColors } = useAppTheme();
  const navigate = useNavigate();
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [status, setstatus] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const searchRef = useRef("");
  const [Role, setRole] = useState("");
  const [openToast, setOpenToast] = useState(false);
  const [options, setOptions] = useState([]);
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Default to 'success'
  const [fetchdatarow, setetchdatarow] = useState([]); // Default to 'success'
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const dateRef = useRef();
  const [age, setAge] = React.useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [editedData, setEditedData] = useState({
    id: "",
    user_name: "",
    fullname: "",
    email: "",
    phone: "",
    role: "",
    page_access: undefined,
  });
  const [pageAccess, setPageAccess] = useState({});
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [balanceSheetPassword, setBalanceSheetPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showBalanceSheetPassword, setShowBalanceSheetPassword] = useState(false);
  const [localrole, Setlocalrole] = useState("");
  const [loginId, SetloginId] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );
  React.useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      // User is not logged in, no need to redirect
      navigate('/');
    }
    
  }, []);
  function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
  }

  const handleToastClose = () => {
    setOpenToast(false);
  };
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const container =
    window1 !== undefined ? () => window().document.body : undefined;

  // useEffect(() => {
  //   // Perform localStorage action
  //   const item = localStorage.getItem('userdata')
  //   if (item ==null){
  //      setredirectpage(true);
  //   }
  //   //console.log("tapan"+item);
  // }, [])
  // if (redirectpage) {

  //   return redirect('/');
  // }

  const handleToggle = (id, status) => {
    setOpenConfirmation(true);
    const newStatus = status === 1 ? 0 : 1;
    setstatus(newStatus);
    setDeleteConfirmationId(id);
    setIsActive(newStatus === 0);
  };

  const handleConfirm = async () => {
    // setIsActive(!isActive);
    // setOpenConfirmation(false);

    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;

      const res = await StatusAdminUser(
        userToken,
        userId,
        status,
        deleteConfirmationId
      );

      if (res.code == "200") {
        handleSnackbarOpen(res.message, "success");
        setIsActive(!isActive);
        setOpenConfirmation(false);
        setOpenDeleteConfirmation(false);
        fetchData(undefined, page);
      } else {
        handleSnackbarOpen(res.message, "error");
        //  console.error(error); // Handle error
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  const handleCancel = () => {
    setOpenConfirmation(false);
  };
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // Fetch one page. A new search starts at page 0; pass the page to stay where you are.
  const fetchData = async (value, pageZero = 0, size = rowsPerPage) => {
    if (value !== undefined) searchRef.current = value || "";
    setLoading(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const role = userDataObj.role;
      SetloginId(userId);
      Setlocalrole(role);
      const res = await retrieveAdminUser(userToken, userId, searchRef.current, size, pageZero * size);

      if (res.code == "200") {
        const rows = Array.isArray(res.data) ? res.data : [];
        // The last row of the last page was just removed: step back one page.
        if (rows.length === 0 && pageZero > 0) {
          await fetchData(undefined, pageZero - 1, size);
          return;
        }
        setetchdatarow(rows);
        setPage(pageZero);
        const total = pickTotal(res);
        setTotalCount(total != null ? total : pageZero * size + rows.length);
      } else {
        setetchdatarow([]);
        setTotalCount(0);
        setPage(0);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSearchChange = (event, value) => {
    const searchText = value || ""; // If value is undefined or empty, set searchText to empty string
    // setSearchText(searchText);
    // Call fetchData function here with the updated searchText
    fetchData(searchText);
  };

  const handleDelete = (id) => {
    handleClose();
    setDeleteConfirmationId(id);
    setOpenDeleteConfirmation(true, id);
  };

  const handleConfirmDelete = async (id) => {
    // setSnackbarMessage('package deleted successfully');
    // setSnackbarSeverity('error');
    // setOpenDeleteConfirmation(false);
    // setOpenToast(true); // Show toast message

    if (deleteConfirmationId !== null) {
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id;

        const res = await DeleteAdminUser(
          userToken,
          userId,
          deleteConfirmationId
        );

        if (res.code == "200") {
          handleSnackbarOpen(res.message, "success");
          setOpenDeleteConfirmation(false);
          fetchData(undefined, page);
        } else {
          handleSnackbarOpen(res.message, "error");
          //  console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error);
        // Handle errors
      }
    }
  };

  const handleCancelDelete = () => {
    setOpenDeleteConfirmation(false);
  };
  const handleInputChange = async (value) => {
    if (value.length >= 3) {
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; // Assuming you have a userId in userdata
        const searchText = value; // Example search text

        const res = await AutocompleteAdminUser(userToken, userId, searchText);

        if (res.code == "200") {
          const names = res.data.map((item) => item.search_data);
          setOptions(names);
        } else {
          handleSnackbarOpen(res.message, "error");
          //  console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error);
        // Handle errors
      }
    }
  };
  const handleEditModalOpen = (id, fullname, email, phone, user_name, role, page_access) => {
    setEditedData({
      id: id,
      fullname: fullname,
      email: email,
      phone: phone,
      user_name: user_name,
      role: role,
      page_access: Array.isArray(page_access) ? page_access : undefined,
    });
    // Initialize page access checkboxes from user's page_access (when role is user)
    if (Array.isArray(page_access) && page_access.length > 0) {
      const next = {};
      page_access.forEach((id) => { next[id] = true; });
      setPageAccess(next);
    } else {
      setPageAccess({});
    }
    setBalanceSheetPassword("");
    setShowPassword(false);
    setShowConfirmPassword(false);
    setShowBalanceSheetPassword(false);
    setEditModalOpen(true);
  };

  const handlePageAccessChange = (id, checked) => {
    setPageAccess((prev) => ({ ...prev, [id]: checked }));
  };

  const handleSelectAllPages = (checked) => {
    const next = {};
    SIDEBAR_PAGE_OPTIONS.forEach((opt) => { next[opt.id] = checked; });
    setPageAccess(next);
  };

  const handleEditModalClose = () => {
    setEditModalOpen(false);
    setPageAccess({});
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    // Reset confirm password error when password is changed
    setConfirmPasswordError("");
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
    // Check if confirm password matches password
    if (event.target.value !== password) {
      setConfirmPasswordError("Passwords do not match");
    } else {
      setConfirmPasswordError("");
    }
  };

  const handleEditSubmit = async () => {
    if (password !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
      return;
    }

    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;

    const payload = {
      ...editedData,
      page_access:
        editedData.role === "user"
          ? Object.keys(pageAccess).filter((k) => pageAccess[k])
          : undefined,
      balanceSheetPassword:
        (editedData.role === "admin" || editedData.role === "user") ? balanceSheetPassword : undefined,
    };

    try {
      const res = await UpdateAdminUser(
        editedData.id,
        userToken,
        payload,
        confirmPassword
      );

      if (res.code == "200" || res.code === 200) {
        handleSnackbarOpen(res.message, "success");
        setConfirmPassword("");
        setPassword("");
        setBalanceSheetPassword("");
        setEditedData({
          id: "",
          user_name: "",
          fullname: "",
          email: "",
          phone: "",
          role: "",
          page_access: undefined,
        });
        setPageAccess({});
        fetchData(undefined, page);
      } else {
        handleSnackbarOpen(res.message, "error");
      }
    } catch (error) {
      console.error(error);
    }

    setEditModalOpen(false);
  };

  const handleRoleChange = (event) => {
    setRole(event.target.value);
  };
  return (
    <Box sx={{ display: "flex", height: "100vh", backgroundColor: "#EFEDF1" }}>
      <CssBaseline />
      <Box>
        <Header />
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, overflowY: "auto", padding: "20px" }}
      >
        <div style={{ display: "flex", flexGrow: 1, marginTop: "50px" }}>
          <div style={{ flex: 1, marginTop: "15px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
              <Box>
                <Typography variant="h5" component="h6" sx={{ color: appColors.evergreen, fontWeight: 600 }}>
                  Users
                </Typography>
              </Box>
              <Box>
                <Button
                  variant="contained"
                  onClick={() => navigate("/adduser")}
                  sx={{
                    bgcolor: appColors.evergreen,
                    '&:hover': { bgcolor: appColors.pine },
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    fontWeight: 700,
                  }}
                >
                  New User
                </Button>
              </Box>
            </Box>

            <Box sx={{ mb: 3 }}>
              <Autocomplete
                freeSolo
                id="free-solo-2-demo"
                disableClearable
                options={options}
                onInputChange={(event, value) => handleInputChange(value)}
                onChange={(event, value) => handleSearchChange(event, value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    sx={{
                      width: { xs: '100%', sm: 300 },
                      "& .MuiInputLabel-root": {
                        textAlign: "center",
                      },
                    }}
                    label="Search input"
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                    }}
                  />
                )}
                sx={{
                  "& .MuiInputBase-root": {
                    alignItems: "center",
                    height: "40px",
                  },
                }}
              />
            </Box>

            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                borderRadius: "10px",
                overflowX: "auto",
                margin: "20px 0",
              }}
            >
              {loading ? (
                <div style={{ textAlign: "center", margin: "50px auto" }}>
                  <CircularProgress sx={{ color: appColors.evergreen }} />
                </div>
              ) : (
                <Table size="small" aria-label="simple table">
                  <TableHead>
                    <TableRow sx={{ bgcolor: appColors.evergreen }}>
                      <TableCell sx={{ color: "#fff", fontWeight: "bold", borderBottom: "none" }}>Name</TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: "bold", borderBottom: "none" }}>Email</TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: "bold", borderBottom: "none" }}>Phone</TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: "bold", borderBottom: "none" }}>User Name</TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: "bold", borderBottom: "none" }}>Role</TableCell>

                      <TableCell sx={{ color: "#fff", fontWeight: "bold", borderBottom: "none" }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fetchdatarow.map((row, indexx) => (
                      <TableRow
                        key={indexx}
                        sx={{
                          "&:nth-of-type(odd)": { backgroundColor: "#f9f9f9" },
                          "&:hover": {
                            backgroundColor: "#e3f2fd",
                            cursor: "pointer",
                          },
                        }}
                      >
                        <TableCell>
                          <Typography>{row.name}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography>{row.email}</Typography>
                        </TableCell>
                        <TableCell align="left">{row.phone}</TableCell>
                        <TableCell align="left">{row.user_name}</TableCell>
                        <TableCell align="left">{row.role}</TableCell>
                        <TableCell align="left" >
                        {localrole === 'admin' || row.id === loginId ? (
                            <Stack 
                              direction="row" 
                              spacing={1}
                              sx={{
                                background: 'linear-gradient(145deg, #ffffff, #f3f4f6)',
                                borderRadius: '12px',
                                padding: '4px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                border: '1px solid #e5e7eb',
                                '.MuiIconButton-root': {
                                  transition: 'all 0.2s ease-in-out',
                                  '&:hover': {
                                    transform: 'translateY(-2px)',
                                  }
                                }
                              }}
                            >
                              <Tooltip title={row.status === 1 ? "Active (Click to Deactivate)" : "Inactive (Click to Activate)"}>
                          <Button
                            onClick={() => handleToggle(row.id, row.status)}
                                  sx={{ 
                                    color: row.status === 1 ? appColors.evergreen : '#dc2626',
                                    bgcolor: row.status === 1 ? 'rgba(31, 122, 84, 0.05)' : 'rgba(220, 38, 38, 0.05)',
                                    borderColor: row.status === 1 ? appColors.evergreen : '#dc2626',
                                    '&:hover': { 
                                      bgcolor: row.status === 1 ? appColors.evergreen : '#dc2626',
                                      color: 'white',
                                      boxShadow: row.status === 1 ? '0 4px 12px rgba(31, 122, 84, 0.15)' : '0 4px 12px rgba(220, 38, 38, 0.15)'
                                    },
                                    minWidth: '40px'
                                  }}
                                >
                                  {row.status === 1 ? <CheckCircleIcon fontSize="small" /> : <CancelIcon fontSize="small" />}
                          </Button>
                              </Tooltip>
                              <Tooltip title="Edit">
                                <Button
                        onClick={() =>
                          handleEditModalOpen(
                            row.id,
                            row.name,
                            row.email,
                            row.phone,
                            row.user_name,
                            row.role,
                            row.page_access
                          )
                        }
                                  sx={{ 
                                    color: appColors.evergreen,
                                    bgcolor: 'rgba(31, 122, 84, 0.05)',
                                    borderColor: appColors.evergreen,
                                    '&:hover': {
                                      bgcolor: appColors.evergreen,
                                      color: 'white',
                                      boxShadow: '0 4px 12px rgba(31, 122, 84, 0.15)'
                                    },
                                    minWidth: '40px'
                                  }}
                                >
                                  <EditIcon fontSize="small" />
                                </Button>
                              </Tooltip>
                              <Tooltip title="Delete">
                                <Button
                        onClick={() => handleDelete(row.id)}
                                  sx={{
                                    color: '#dc2626',
                                    bgcolor: 'rgba(220, 38, 38, 0.05)',
                                    borderColor: '#dc2626',
                                    '&:hover': {
                                      bgcolor: '#dc2626',
                                      color: 'white',
                                      boxShadow: '0 4px 12px rgba(220, 38, 38, 0.15)'
                                    },
                                    minWidth: '40px'
                                  }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </Button>
                              </Tooltip>
                            </Stack>
                          ) : (
                            <Typography
                              sx={{
                                color: row.status === 1 ? appColors.evergreen : 'error.main',
                                fontWeight: 500
                              }}
                            >
                              {row.status === 1 ? "Active" : "Inactive"}
                            </Typography>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <ListPagination
                count={totalCount}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={(p) => fetchData(undefined, p)}
                onRowsPerPageChange={(size) => { setRowsPerPage(size); fetchData(undefined, 0, size); }}
              />
            </div>
          </div>
        </div>
      </Box>
      <Dialog
        open={openDeleteConfirmation}
        onClose={handleCancelDelete}
        fullWidth="sm"
      >
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this User?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            startIcon={<CancelIcon />}
            sx={{ fontWeight: "bold", textTransform: "none" }}
            onClick={handleCancelDelete}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            sx={{ fontWeight: "bold", textTransform: "none" }}
            variant="contained"
            startIcon={<DeleteIcon />}
            color="error"
          >
            {" "}
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
      <Dialog open={openConfirmation} onClose={handleCancel}>
        <DialogTitle>{isActive ? "Deactivate" : "Activate"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isActive
              ? "Are you sure you want to deactivate this item?"
              : "Are you sure you want to activate this item?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ fontWeight: "bold", textTransform: "none" }}
            startIcon={<CancelIcon />}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            sx={{ fontWeight: "bold", textTransform: "none" }}
            variant="contained"
            startIcon={<CheckCircleIcon />}
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog 
        open={editModalOpen} 
        onClose={handleEditModalClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            bgcolor: 'background.paper'
          }
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: appColors.evergreen,
            color: 'white',
            px: 3,
            py: 2,
            fontSize: '1.2rem',
            fontWeight: 600
          }}
        >
          Edit User Details
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            {/* Personal Information */}
            <Typography variant="subtitle2" sx={{ color: appColors.evergreen, fontWeight: 600, mb: 1 }}>
              Personal Information
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
                fullWidth
                label="Full Name"
              value={editedData.fullname}
              onChange={(e) =>
                setEditedData({ ...editedData, fullname: e.target.value.toUpperCase() })
              }
                size="small"
                InputProps={{
                  sx: { borderRadius: 1 }
                }}
            />
            <TextField
                fullWidth
                label="Username"
                value={editedData.user_name}
                onChange={(e) =>
                  setEditedData({ ...editedData, user_name: e.target.value.toUpperCase() })
                }
                size="small"
                InputProps={{
                  sx: { borderRadius: 1 }
                }}
              />
            </Box>

            {/* Contact Information */}
            <Typography variant="subtitle2" sx={{ color: appColors.evergreen, fontWeight: 600, mb: 1, mt: 1 }}>
              Contact Information
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                fullWidth
              label="Email"
              type="email"
              value={editedData.email}
              onChange={(e) =>
                setEditedData({ ...editedData, email: e.target.value.toLowerCase() })
              }
                size="small"
                InputProps={{
                  sx: { borderRadius: 1 }
                }}
            />
            <TextField
                fullWidth
              label="Phone"
              type="number"
              value={editedData.phone}
              onChange={(e) =>
                setEditedData({ ...editedData, phone: e.target.value })
              }
                size="small"
                InputProps={{
                  sx: { borderRadius: 1 }
                }}
              />
            </Box>

            {/* Role Selection */}
            <Typography variant="subtitle2" sx={{ color: appColors.evergreen, fontWeight: 600, mb: 1, mt: 1 }}>
              Role & Access
            </Typography>
            <FormControl fullWidth size="small">
              <InputLabel>Role</InputLabel>
              <Select
                value={editedData.role}
                label="Role"
                onChange={(e) => {
                  const role = e.target.value;
                  if (role !== "user") setPageAccess({});
                  setEditedData({ ...editedData, role });
                }}
                sx={{ borderRadius: 1 }}
              >
                <MenuItem value="">Select Role</MenuItem>
                <MenuItem value="admin">Admin</MenuItem>
                <MenuItem value="user">User</MenuItem>
                <MenuItem value="editor">Editor</MenuItem>
                <MenuItem value="viewer">Viewer</MenuItem>
              </Select>
            </FormControl>

            {(editedData.role === "admin" || editedData.role === "user") && (
              <Box sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  label="Balance Sheet Password"
                  type={showBalanceSheetPassword ? "text" : "password"}
                  size="small"
                  value={balanceSheetPassword}
                  onChange={(e) => setBalanceSheetPassword(e.target.value)}
                  helperText="Leave blank to keep the current balance sheet password unchanged"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowBalanceSheetPassword((prev) => !prev)}
                          edge="end"
                          size="small"
                        >
                          {showBalanceSheetPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': { borderRadius: 1 },
                  }}
                />
              </Box>
            )}

            {editedData.role === "user" && (
              <Box sx={{ mt: 1 }}>
                <Typography variant="subtitle2" sx={{ color: appColors.evergreen, fontWeight: 600, mb: 1 }}>
                  Page access (which pages this user can access)
                </Typography>
                <FormGroup row sx={{ flexWrap: "wrap", gap: 0.5 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          SIDEBAR_PAGE_OPTIONS.length > 0 &&
                          SIDEBAR_PAGE_OPTIONS.every((opt) => pageAccess[opt.id])
                        }
                        indeterminate={
                          Object.keys(pageAccess).some((k) => pageAccess[k]) &&
                          !SIDEBAR_PAGE_OPTIONS.every((opt) => pageAccess[opt.id])
                        }
                        onChange={(e) => handleSelectAllPages(e.target.checked)}
                      />
                    }
                    label="Select all"
                  />
                  {SIDEBAR_PAGE_OPTIONS.map((opt) => (
                    <FormControlLabel
                      key={opt.id}
                      control={
                        <Checkbox
                          checked={!!pageAccess[opt.id]}
                          onChange={(e) => handlePageAccessChange(opt.id, e.target.checked)}
                        />
                      }
                      label={opt.label}
                    />
                  ))}
                </FormGroup>
              </Box>
            )}

            {/* Password Reset */}
            <Typography variant="subtitle2" sx={{ color: appColors.evergreen, fontWeight: 600, mb: 1, mt: 1 }}>
              Password Reset
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
                fullWidth
              type={showPassword ? "text" : "password"}
                label="New Password"
              value={password}
              onChange={handlePasswordChange}
                size="small"
                InputProps={{
                  sx: { borderRadius: 1 },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((prev) => !prev)}
                        edge="end"
                        size="small"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
            />
            <TextField
                fullWidth
              type={showConfirmPassword ? "text" : "password"}
                label="Confirm Password"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              error={!!confirmPasswordError}
              helperText={confirmPasswordError}
                size="small"
                InputProps={{
                  sx: { borderRadius: 1 },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowConfirmPassword((prev) => !prev)}
                        edge="end"
                        size="small"
                      >
                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
            />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
          <Button
            onClick={handleEditModalClose}
            variant="outlined"
            sx={{ 
              color: appColors.evergreen,
              borderColor: appColors.evergreen,
              '&:hover': {
                borderColor: appColors.pine,
                bgcolor: 'rgba(31, 122, 84, 0.04)'
              },
              textTransform: 'none',
              fontWeight: 500
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleEditSubmit}
            variant="contained"
            sx={{
              bgcolor: appColors.evergreen,
              '&:hover': { bgcolor: appColors.pine },
              textTransform: 'none',
              fontWeight: 500
            }}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default UserList;